document.addEventListener( 'DOMContentLoaded', () => {

    const openItem = ( item ) => {
        const trigger = item.querySelector( '.faq__trigger' );
        const body    = item.querySelector( '.faq__body' );

        if ( trigger.getAttribute( 'aria-expanded' ) === 'true' ) return;

        body.hidden = false;
        body.style.height = '0';
        requestAnimationFrame( () => {
            requestAnimationFrame( () => {
                body.style.height = body.scrollHeight + 'px';
            } );
        } );
        body.addEventListener( 'transitionend', () => {
            body.style.height = '';
        }, { once: true } );
        trigger.setAttribute( 'aria-expanded', 'true' );
    };

    const closeItem = ( item ) => {
        const trigger = item.querySelector( '.faq__trigger' );
        const body    = item.querySelector( '.faq__body' );

        if ( trigger.getAttribute( 'aria-expanded' ) === 'false' ) return;

        body.style.height = body.scrollHeight + 'px';
        requestAnimationFrame( () => {
            requestAnimationFrame( () => {
                body.style.height = '0';
            } );
        } );
        body.addEventListener( 'transitionend', () => {
            body.hidden = true;
            body.style.height = '';
        }, { once: true } );
        trigger.setAttribute( 'aria-expanded', 'false' );
    };

    // click handler
    document.querySelectorAll( '.faq__trigger' ).forEach( ( trigger ) => {
        trigger.addEventListener( 'click', () => {
            const item   = trigger.closest( '.faq__item' );
            const isOpen = trigger.getAttribute( 'aria-expanded' ) === 'true';

            if ( isOpen ) {
                closeItem( item );
                history.replaceState( null, '', window.location.pathname );
            } else {
                openItem( item );
                history.replaceState( null, '', '#' + item.id );
            }
        } );
    } );

    // on load — handle hash
    if ( window.location.hash ) {
        const id   = window.location.hash.substring( 1 );
        const item = document.getElementById( id );

        if ( item && item.classList.contains( 'faq__item' ) ) {
            openItem( item );
            setTimeout( () => {
                item.scrollIntoView( { behavior: 'smooth', block: 'start' } );
            }, 100 );
        }
    }

} );